import { connect } from 'react-redux';
import { push } from 'react-router-redux/lib/actions';
import Component from './component';
import managerCRUDActions from '../../../actions/manager';
import {getManagersConfig} from '../managersConfig';

export default connect(
  (state) => ({
    ...getManagersConfig(state.auth.user.club.id),
    isNew: true,
    loading: state.manager.loading,
    model: state.manager.model,
    initialValues: {club_id: state.auth.user.club.id,}
  }),
  dispatch => ({
    fetch: () => dispatch(managerCRUDActions.createModel()),
    goIndex: () => dispatch(push('/managers'))
  })
)(Component);



// WEBPACK FOOTER //
// ./src/components/Managers/ManagersNew/index.js